module cr.entity
{
    entityModule.directive('crTreeContent', function () {
        return {
            restrict: "E",
            scope: true,
            templateUrl: "modules/entity/views/treecontent.html",
            require: "^crTreeViewer",
            link: function (scope, element, attrs, treeViewer) {
                scope.treeViewer = treeViewer;
                scope.tree = treeViewer.getTree();

                console.log("constructeur fils: " + scope.tree.nodes.length);
            },
            controller: function ($scope, $q) {
                //console.log("constructeur fils: "+$scope.tree.nodes.length);
                //console.log("treeCtrl: "+$scope.treeCtrl.getSelectedNode());
                // console.log("treeCtrl: "+$scope.treeCtrl.getSelectedNode());
            }
        }
    });
}
